import React from 'react'
import { SOCIAL_LINKS } from '../../types/navigation'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Lucas Stufflebeam</h3>
            <p className="footer-subtitle">Principal Software Architect</p>
          </div>

          <div className="footer-section">
            <div className="contact-info">
              <span className="availability">Currently employed</span>
            </div>
          </div>

          <div className="footer-section">
            <div className="footer-links">
              {SOCIAL_LINKS.map(link => (
                <a
                  key={link.label}
                  href={link.url}
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit ${link.label} profile`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© {currentYear} Lucas Stufflebeam.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
